var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "glob",
    x: 0,
    y: 0,
    width: 320,
    height: 320,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 160,
    r: 120,
    style: {
      fill: "#fff",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,80c-0,0 -27.243,3.897 -40,10c-14.152,6.771 -31.831,18.576 -30,70c1.779,49.968 -17.692,61.541 -40,60c-22.533,-1.557 -15.399,-2.003 -40,-10c-30.074,-9.776 -30,16.319 -30,16.319",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,50.897c-0,-0 -10,19.103 -0,39.103c10,20 20,40 20,60c-0,20 -10.099,21.406 -20,20c-9.135,-1.297 -76.198,-19.416 -67.387,-35",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,112c-0,-3.271 -26.595,9.149 -40,18c-19.17,12.657 -24.243,45.417 -20,60c7.906,27.17 36.376,60.132 39.413,50",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlob);
export default __webpack_public_path__ + "static/media/glob.7abde47fc9100789cb85245eaab5867e.svg";
export { ForwardRef as ReactComponent };